<template>

  <div v-if="state.sectionShown" class="block md:flex w-full">
    <div class="w-full md:w-[50%]">
      <p class="lg:text-[64px] text-[32px] font-semibold leading-[90%]">Nejčastější<br>dotazy</p>
    </div>
    <div class="w-full md:w-[50%]">
      <div>
        <Faq v-for="faq in (state.full ? state.faqs : state.faqs.slice(0, 3))" :key="faq._uid" :faq="faq" />
      </div>
      <div v-if="!state.full" @click="state.full = true" class="mt-4 ">
        <div class="flex cursor-pointer hover:text-brand-green items-center">
          <svg
            class="mb-1 transition-all duration-300 transform group-hover:scale-110 mr-4 mt-1"
            width="16"
            height="16"
            viewBox="0 0 800 800"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_677_483)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M550 425H425V550C425 563.75 413.825 575 400 575C386.175 575 375 563.75 375 550V425H250C236.175 425 225 413.75 225 400C225 386.25 236.175 375 250 375H375V250C375 236.25 386.175 225 400 225C413.825 225 425 236.25 425 250V375H550C563.825 375 575 386.25 575 400C575 413.75 563.825 425 550 425ZM400 0C179.075 0 0 179 0 400C0 621 179.075 800 400 800C620.925 800 800 621 800 400C800 179 620.925 0 400 0Z" fill="#9EFC4E"/>
            </g>
            <defs>
              <clipPath id="clip0_677_483">
                <rect width="800" height="800" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          Zobrazit více
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>
import Faq from './Faq.vue';

import { onMounted, reactive } from "vue";
import { useStoryblokBridge } from "@storyblok/vue";
import useStoryBlokData from '../../composables/useStoryBlokData';

const { getStoryBlokData } = useStoryBlokData();

const state = reactive({
  faqs: null,
  sectionShown: false,
  full: false,
});

onMounted(async () => {
  const { data } = await getStoryBlokData();

  const node = data.story.content.body.find(bodyElements => bodyElements.id === 'faqs');

  state.faqs = node.faq;
  state.sectionShown = node.shown;

  useStoryblokBridge(data.story.id, (story) => {
    const node = story.content.body.find(bodyElements => bodyElements.id === 'faqs');

    state.faqs = node.faq;
    state.sectionShown = node.shown;
  });
});

</script>

<style>

</style>
